import { api } from "./api";

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const loadPlans = async (codigo_ibge) => {
  
  const resposta = await api(`${ENDPOINT}/plans/${codigo_ibge}`, {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });

  const data = await resposta.json().then((res) => {
    return res.map((item) => ( console.log('item', item), {
      id: item.forma_pagamento_id,
      nome: item.nome_impressao,
      qtd_dependentes: item.parcelas - 1,
      beneficios: item.beneficios_plano,
      parcelas: item.valor_parcelas,
      recomendado: item.recomendado,
      menor_valor_por_forma: item.menor_valor_por_forma,
    }));
  });

  return data;
};

const loadPlansBlackFriday = async () => {
  const resposta = await api(`${ENDPOINT}/plans/black-friday`, {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });

  
  const data = await resposta.json().then((res) => {
    console.log('resposta', res);
    return res.map((item) => ({
      id: item.forma_pagamento_id,
      nome: item.nome_impressao,
      qtd_dependentes: item.parcelas - 1,
      beneficios: item.beneficios_plano,
      parcelas: item.valor_parcelas,
      recomendado: item.recomendado,
      telemedicina_ilimitada: item.telemedicina_ilimitada,
    }));
  });

  return data;
};

const getPagamentos = async (idPlano, frequencia, codigo_ibge) => {
  const resposta = await api(`${ENDPOINT}/plans/${idPlano}/pagamentos/${frequencia}/${codigo_ibge}`, {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });

  return await resposta.json();
};

export { getPagamentos, loadPlans, loadPlansBlackFriday };
